<link rel="stylesheet" href="https://cdn.jsdelivr.net/gh/openlayers/openlayers.github.io@master/en/v6.5.0/css/ol.css"
  type="text/css">
<div id="carte">
  <div id="map" class="no-select"></div>
  <ng-template #popupContainer></ng-template>
  <app-slide-menu [toggle]="true" />
  <app-position-gadget [currentCoordinate]="mousePosition" [isDegre]="isDegre" />

  <div class="map-filter-control">
    <button type="button" class="map-filter-button" [ngClass]="{ active: showFilterPanel }" (click)="toggleFilterPanel()" aria-label="Filter">
      <i class="fa-solid fa-sliders"></i>
    </button>

    <div class="map-filter-panel" *ngIf="showFilterPanel">
      <div class="filter-header">
        <i class="fa-solid fa-sliders"></i>
        <strong>{{ 'MAP.FILTER' | translate }}</strong>
      </div>
      <div class="filter-row">
        <label class="switch">
          <input type="checkbox" [(ngModel)]="showVibrationRecords" (ngModelChange)="onViewRecordsToggle()" />
          <span class="slider round"></span>
        </label>
        <span>{{ 'MAP.VIEW_RECORDS' | translate }}</span>
      </div>
    </div>
  </div>
  <app-carte-controllers-gadget [selectedBtn]="selectedMapLayerButton" (btnBingMap)="layerSwitch(3)" (btnZoom)="zoom($event)" />
  <div id="custom-toast-container"></div>
  <div id="custom-scale-line" class="custom-scale-line">
    <span id="scale-text">100 m</span>
    <div id="scale-bar" class="scale-bar"></div>
  </div>
</div>